// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2fF4m","loader":"styles_loader__JyMY0"};